
  import { createRoot } from "react-dom/client";
  import App from "./App.tsx";
  import "./index.css";
  import "./shared/utils/debugHelpers";
  import { initialiserInstallation } from "./shared/pwa/installation";

  initialiserInstallation();

  createRoot(document.getElementById("root")!).render(<App />);
  